import "./EditExpenseReportForm.css";
import { useNavigate } from "react-router-dom";
import { ExpenseReport } from "../models/expense_report";
import { apiCall } from "../api/apiCall";
import { useState } from "react";
import { useTranslation } from "../i18n/UseTranslation";

type UpdateExpenseReportStatusCardProps = {
  expenseReport: ExpenseReport;
  userRole: string;
};

function UpdateExpenseReportStatusCard({
  expenseReport,
  userRole,
}: UpdateExpenseReportStatusCardProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleUpdateStatus = async (
    status: "APPROVED" | "REJECTED" | "REIMBURSED",
  ) => {
    const confirmMsg =
      t.updateExpenseStatus?.confirmTransition?.replace("{status}", status) ||
      `Are you sure you want to set this report to ${status}?`;

    const confirmed = window.confirm(confirmMsg);

    if (!confirmed) return;

    setLoading(true);

    try {
      await apiCall(`/expense-reports/${expenseReport.uuid}/status`, {
        method: "PATCH",
        body: JSON.stringify({ status }),
      });

      const successMsg =
        t.updateExpenseStatus?.updateSuccess?.replace("{status}", status) ||
        `Expense report updated to ${status}`;

      alert(successMsg);
      navigate(`/expense-reports/${expenseReport.uuid}`);
    } catch (error) {
      console.error("Error updating status:", error);
      alert(t.updateExpenseStatus?.updateError || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-expense-form-page">
      <div className="edit-expense-form-card">
        <div className="edit-expense-form-header">
          <div>
            <h1>{t.updateExpenseStatus?.title || "Update Expense Status"}</h1>
            <p>
              {t.updateExpenseStatus?.currentStatus || "Current status:"}{" "}
              {expenseReport.status}
            </p>
          </div>
        </div>

        <div className="status-card-actions">
          {expenseReport.status === "PENDING" && (
            <>
              {userRole?.toLowerCase() !== "accountant" && (
                <button
                  className="status-big-btn approve-btn"
                  onClick={() => handleUpdateStatus("APPROVED")}
                  disabled={loading}
                >
                  {t.updateExpenseStatus?.approve || "Approve"}
                </button>
              )}

              <button
                className="status-big-btn reject-btn"
                onClick={() => handleUpdateStatus("REJECTED")}
                disabled={loading}
              >
                {t.updateExpenseStatus?.reject || "Reject"}
              </button>
            </>
          )}

          {expenseReport.status === "APPROVED" && (
            <button
              className="status-big-btn reimbursed-btn"
              onClick={() => handleUpdateStatus("REIMBURSED")}
              disabled={loading}
            >
              {t.updateExpenseStatus?.markReimbursed || "Mark as reimbursed"}
            </button>
          )}

          {expenseReport.status !== "PENDING" &&
            expenseReport.status !== "APPROVED" && (
              <div className="status-info-box">
                {t.updateExpenseStatus?.noTransition ||
                  "No status transition available for this expense report."}
              </div>
            )}
        </div>

        <div className="edit-expense-form-actions">
          <button
            type="button"
            className="secondary-btn"
            onClick={() => navigate(-1)}
          >
            {t.updateExpenseStatus?.back || "Back"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateExpenseReportStatusCard;
